import React from 'react';
import {Col, Layout, Row} from 'antd';

import logo_br from 'images/icon/logo_bg_2.png';

import styles from './footer.module.scss';

const Footer: React.FC = () => {
    return (
        <Layout.Footer className={styles.wrap}>
            <div className={styles.main}>
                <Row type="flex" justify="space-between">
                    <Col md={12} xs={24} sm={24}>
                        <div className="footer_contacts">
                            Організатор - Валентина Ткаченко
                            <span className="number_contact">+38 097 239 72 70</span>
                        </div>
                    </Col>
                    <Col md={12} xs={24} sm={24}>
                        <div className="footer-right-block">
                            Сайт створено
                            <a href="https://brightech.it/">
                                <img src={logo_br} alt="" />
                            </a>
                        </div>
                    </Col>
                </Row>
            </div>
        </Layout.Footer>
    );
};

export default Footer;
